import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@material-ui/core/";

import {useTranslation} from 'react-i18next';

export default function ResetConfirmDialog(props) {
  const { onDialogClose, dialogOpen } = props;
   const {t} = useTranslation();
  const handleClose = (accepted) => {
    onDialogClose(accepted);
  };

  return (
    <div>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        open={dialogOpen}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {t("other.titleClearHeader")}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
           {t("other.clearDialog")}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleClose(false)} color="secondary">
            {t("pgReview.btnNo")}
          </Button>
          <Button onClick={() => handleClose(true)} color="primary" autoFocus>
          {t("pgReview.btnYes")}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ResetConfirmDialog.propTypes = {
  dialogOpen: PropTypes.bool,
  onDialogClose: PropTypes.func,
};
